'use strict';

exports.__esModule = true;
var __PROD__ = exports.__PROD__ = process.env.NODE_ENV === 'production';
var __CI__ = exports.__CI__ = !!process.env.CI;
var __DEV__ = exports.__DEV__ = !__PROD__ && !__CI__;